import { render, staticRenderFns } from "./ProductNameFormation.vue?vue&type=template&id=57752f03&scoped=true"
import script from "./ProductNameFormation.vue?vue&type=script&lang=js"
export * from "./ProductNameFormation.vue?vue&type=script&lang=js"
import style0 from "./ProductNameFormation.vue?vue&type=style&index=0&id=57752f03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57752f03",
  null
  
)

export default component.exports